import React from 'react'
import PropTypes from 'prop-types'
import { CSSTransition } from 'react-transition-group'

import classNames from 'classnames'

import ProductImage from '../product-image'

import style from './index.module.scss'

const FIRST = 0

const FADE_IN = 300 // ms
const FADE_OUT = 100 // ms
const MAX_IMAGES = 4

const transitionClassNames = {
  enter: style.primaryImageEnter,
  enterDone: style.primaryImageEnterDone,
  exit: style.primaryImageExit,
  exitDone: style.primaryImageExitDone,
}

function generateThumbs(imageList) {
  // Limit the images to 4, and pad if less than four
  // If there is only one we don't want to show any thumbs
  // so thumb list will be shims only
  return imageList.length === 1
    ? new Array(MAX_IMAGES)
    : [
        ...imageList.slice(0, MAX_IMAGES),
        ...new Array(MAX_IMAGES - imageList.slice(0, MAX_IMAGES).length),
      ]
}

export default class ProductImageGallery extends React.Component {
  static propTypes = {
    images: PropTypes.arrayOf(PropTypes.string),
    tag: PropTypes.string,
    name: PropTypes.string.isRequired,
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.name !== prevState.name) {
      return Object.assign(prevState, {
        selectedSrc: nextProps.images[FIRST],
        thumbList: generateThumbs(nextProps.images),
        name: nextProps.name,
      })
    }
    return null
  }

  constructor(props) {
    super(props)

    const thumbList = generateThumbs(props.images)

    this.state = {
      selectedSrc: props.images[FIRST],
      nextSrc: null,
      showPrimary: true,
      thumbList,
      name: props.name,
    }
  }

  imageName = () => this.state.selectedSrc.split('/').reverse()[0]

  showNext = () => {
    const nextSrc = this.state.nextSrc
    this.setState({
      selectedSrc: nextSrc,
      nextSrc: null,
      showPrimary: true,
    })
  }

  handleImageClick = event => {
    if (event.currentTarget !== undefined) {
      const img = event.currentTarget.querySelector('img')

      const IMAGE_DOES_NOT_EXIST = -1
      if (img.src.indexOf(this.imageName()) === IMAGE_DOES_NOT_EXIST) {
        // if not the current selected image
        this.setState({ nextSrc: img.src, showPrimary: false })
      }
    }
  }

  render() {
    return (
      <div className={style.productImageGallery}>
        <CSSTransition
          in={this.state.showPrimary}
          timeout={this.state.showPrimary ? FADE_IN : FADE_OUT}
          classNames={transitionClassNames}
          onExited={this.showNext}
        >
          <ProductImage
            className={style.primaryImage}
            src={this.state.selectedSrc}
            tag={this.props.tag}
            alt={this.props.name}
          />
        </CSSTransition>
        <div id="thumbnail-strip" className={style.thumbnailStrip}>
          {this.state.thumbList.map((current, index) =>
            current === undefined ? (
              <div
                key={index}
                className={classNames(style.thumbnailContainer, style.shim)}
              />
            ) : (
              <button
                key={index}
                className={classNames(
                  style.thumbnailContainer,
                  current.indexOf(this.imageName()) >= 0 ? style.selected : null
                )}
                aria-label={`Update main product image with image ${index + 1}`}
                onClick={this.handleImageClick}
              >
                <ProductImage
                  src={current}
                  alt={`${this.props.name}-thumbnail-${index}`}
                />
              </button>
            )
          )}
        </div>
      </div>
    )
  }
}
